<template>
  <div>
    <div v-if="userRole !== 'guest'" class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" disabled>{{locale.save}}</button>
    </div>
    <div v-if="userRole !== 'guest'" class="btnGroup">
      <router-link to="/menu/item" class="btn btnFull">{{locale.menu_create}}</router-link>
      <button type="button" class="btn btnFull" @click="setMain">{{locale.menu_apply}}</button>
      <button type="button" class="btn btnFull btnRed" @click="onRemove">{{locale.delete}}</button>
    </div>
    <div v-if="!!templates && templates.length > 0" class="btnTemplate checkbox">
      <input type="checkbox" id="show_templates" :checked="showTemplates" @change="checkShowTemplates">
      <label for="show_templates">{{locale.template}}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SetMenuList',
  props: [
    'locale',
    'checked',
    'list',
    'templates',
    'showTemplates'
  ],
  computed: {
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    },
    mainId () {
      return this.$store.state.setting.main.menu
    }
  },
  methods: {
    checkShowTemplates () {
      this.$emit('checkTemplates', !this.showTemplates)
    },
    validateSetMain () {
      if (this.checked.length === 0) {
        alert(this.locale.validate_menu_main_noitem)
        return false
      } else if (this.checked.length > 1) {
        alert(this.locale.validate_menu_main_one)
        return false
      } else if (this.checked.includes(this.mainId)) {
        alert(this.locale.validate_menu_main_already)
        return false
      } else {
        return true
      }
    },
    async setMain () {
      let isPassed = this.validateSetMain()
      if (isPassed) {
        if (window.confirm(this.locale.confirm_menu_main)) {
          const mainId = this.checked[0]

          this.$store.commit('onLoading', true)
          const setting = await this.$store.dispatch('setting/getSetting')
          if (setting) {
            const settingData = setting
            settingData.main.menu = mainId
            await this.$store.dispatch('setting/setData', { data: setting, responsive: 'mobile' })
            await this.$store.dispatch('setting/setSetting', settingData)
            alert(this.locale.complete_application)
            this.$emit('uncheckedAll')
            this.$store.commit('onLoading', false)
          } else {
            alert('설정파일을 찾을 수 없습니다.\n설정 메뉴에서 우선 저장해주세요.')
          }
          this.$store.commit('onLoading', false)
        }
      }
    },
    validateOnRemove () {
      if (!this.checked.length) {
        alert(this.locale.validate_menu_delete_noitem)
        return false
      } else if (this.checked.includes(this.mainId)) {
        alert(this.locale.validate_page_delete_main)
        return false
      } else {
        return true
      }
    },
    onRemove () {
      let isPassed = this.validateOnRemove()
      if (isPassed) {
        if (window.confirm(this.locale.confirm_delete_menu)) {
          const ids = this.checked
          let promises = []
          this.$store.commit('onLoading', true)
          ids.forEach(id => {
            promises.push(
              this.$store.dispatch('menu/delMenuItem', id)
            )
          })
          this.$http.all(promises).then(() => {
            this.$store.dispatch('menu/delMenuListItem', ids).then(() => {
              this.$store.dispatch('menu/setMenuListData').then(() => {
                alert(this.locale.complete_delete)
                this.$emit('uncheckedAll')
                this.$store.commit('onLoading', false)
              })
            })
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btnTemplate {
  display: block;
  margin-right: 0;
  padding: 0.6em 15px;
  border: 1px solid $color-lgrey2;
}
</style>
